import axios from "axios";
import { loadingService } from "../services/loadingService";

const client = axios.create({
  //baseURL: process.env.REACT_APP_API_URL || "http://localhost:5218/api",
  baseURL:
    process.env.REACT_APP_API_URL || "https://quanta.vrglobalsoft.com/api",
  timeout: Number(process.env.REACT_APP_API_TIMEOUT || 30000),
});

client.interceptors.request.use((config) => {
  if (!config.skipGlobalLoading) loadingService.start();
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  return config;
});

client.interceptors.response.use(
  (response) => {
    if (!response.config?.skipGlobalLoading) loadingService.stop();
    return response;
  },
  (error) => {
    if (!error.config?.skipGlobalLoading) loadingService.stop();
    if (error.response?.status === 401 && !error.config?.skipAuthRedirect) {
      localStorage.removeItem("token");
      localStorage.removeItem("erpUser");
      if (!window.location.pathname.includes("/login")) {
        window.location.href = `/login?redirectUrl=${encodeURIComponent(window.location.pathname)}`;
      }
    }
    const apiMessage =
      error.response?.data?.message ||
      error.response?.data ||
      error.message ||
      "API request failed";
    error.userMessage =
      typeof apiMessage === "string" ? apiMessage : "API request failed";
    return Promise.reject(error);
  },
);

export default client;
